import { render, staticRenderFns } from "./ReceiptSummary.vue?vue&type=template&id=c68e04b2"
import script from "./ReceiptSummary.vue?vue&type=script&lang=js"
export * from "./ReceiptSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports